<template>
    <div>
        <MonthlyHeader page-type="manage" class="no_print">
            <template v-slot:menu_left><div class="icn_green"><p role="button" @click.prevent.stop="operationCheck('cancel')">＜戻る</p></div>
            </template>
            <template v-slot:menu_center>
                <div class="menu_calendar_unit">
                    <p class="menu_calendar_prev" role="button" @click.prevent.stop="operationCheck('befoer')"><i class="fas fa-chevron-left"></i>前月</p>
                    <p class="menu_calendar_date">{{year}}年{{month}}月</p>
                    <p class="menu_calendar_next" role="button" @click.prevent.stop="operationCheck('next')">翌月<i class="fas fa-chevron-right"></i></p>
                </div>
            </template>
            <template v-slot:menu_right>
                <div class="btn_check letter_spa">
                    <a role="button" @click.stop.prevent="onClick">確認</a>
                </div>
            </template>
            <template v-slot:menu_csv>
                <div class="btn_check_csv">
                    <a role="button" @click.stop.prevent="topButtonNo = 1">CSV出力</a>
                </div>
            </template>
        </MonthlyHeader>
        <ReportMonthly @submitted="onSubmitted" :date="date()" :confirmed="confirmed" :commentReFlg="commentFlg" :topButtonNo.sync="topButtonNo"></ReportMonthly>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">コメント登録確認</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>入力したコメントはまだ登録されていません。画面遷移すると入力したコメント破棄されます。画面遷移してよろしいですか？</p>
                    </div>
                    <div class="btn_submit_box">
                        <div class="btn_submit2">
                            <a href="#" @click.prevent.stop="closeCheckModel">キャンセル</a>
                        </div>
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="actionCall">OK</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import MonthlyHeader from '@/app/components/MonthlyHeader.vue'
    import ReportMonthly from '@/app/components/ReportMonthly.vue'
    export default {
        name: 'ReportMonthlyDetail',
        components: {
            MonthlyHeader,
            ReportMonthly,
        },
        props: {
            year: {
                type: Number,
                required: true,
            },
            month: {
                type: Number,
                required: true,
            },
            day: {
                type: Number,
                required: true,
            },
        },
        data () {
            return {
                showContent: false,
                commentFlg: false,
                isLastPage: false,
                confirmed: false,
                topButtonNo: null,
            }
        },
        computed: {
            prevMonth: function () {
                let month = this.date()
                month.setMonth(month.getMonth()-1)
                return month
            },
            nextMonth: function () {
                let month = this.date()
                month.setMonth(month.getMonth()+1)
                return month
            },
        },
        methods: {
            date: function () {
                return new Date(this.year, this.month-1, this.day)
            },
            onClick: function () {
                this.confirmed = true
            },
            onSubmitted: function (result) {
                this.confirmed = false
                if (!result) {
                    return
                }
                this.$store.dispatch('dialog/setDialog', {
                    title: '報告書確認',
                    text: '報告書の確認が完了しました。',
                    button: {
                        cancel: { show: false, text: null },
                        done: { show: true, text: 'OK' }
                    },
                    next: null,
                    show: true,
                })

                // コメント差分フラグを初期化
                this.commentFlg = false;
            },
            onBefoer() {
                // 前月
                this.actionStatus = "";
                this.$router.push(
                    {
                        name: 'monthlyreport',
                        params: {year: this.prevMonth.getFullYear(), month: this.prevMonth.getMonth()+1, day: this.prevMonth.getDate()}
                    })
            },
            onNext() {
                // 翌月
                this.actionStatus = "";
                this.$router.push(
                    {
                        name: 'monthlyreport',
                        params:{year:this.nextMonth.getFullYear(), month: this.nextMonth.getMonth()+1, day: this.nextMonth.getDate()}
                    })
            },
            onCancel() {
                // 戻る
                this.actionStatus = "";
                this.$router.push(
                    {
                        name: 'calendar',
                        params: {year: this.year, month:this.month}
                    })
            },
            operationCheck(action){
                this.actionStatus = action;
                if(this.commentFlg){
                    this.showContent = true;
                    return null;
                }
                // 差分がない場合
                this.actionCall();
            },
            actionCall(){
                // 判定フラグを初期化
                this.commentFlg = false;
                this.showContent = false;
                switch (this.actionStatus) {
                    case "befoer":
                        this.onBefoer();
                        break;
                    case "next":
                        this.onNext();
                        break;
                    case "cancel":
                        this.onCancel();
                        break;
                }
            },
            closeCheckModel(){
                this.showContent = false;
            },
        },
    }
</script>
